import { BehaviorSubject, Observable, Observer } from 'rxjs';
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  private _apiKey: string = '';
  public apiKey$ = new BehaviorSubject<string>(null);


  constructor(private router: ActivatedRoute) {
    // if (!this._apiKey) {
    //   this.router.paramMap.subscribe((p: any) => {
    //     let { apiKey } = p.params;
    //     this.apiKey$.next(apiKey);
    //     this.apiKey$.complete();
    //     this._apiKey = apiKey;
    //   })
    // }
  }

  get apiKey(): string {
    return this._apiKey;
  }



  set apiKey(value) {
    this.apiKey$.next(value);
    this.apiKey$.complete();
    this._apiKey = value;
  }
}
